interface EncuestaLayoutProps {
  children: React.ReactNode
}

export function EncuestaLayout({ children }: EncuestaLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <div className="mx-auto max-w-2xl px-4 py-8">
        {children}
      </div>
    </div>
  )
}
